import React from "react";
import { useParams } from "react-router-dom";
import DisplayLayout from "../../components/layout/DisplayLayout";
import DonationFooter from "./DonationFooter";
import DynamicDonation from "./DynamicDonation";
import FixedDonation from "./FixedDonation";
import donations from "../../data/donations";
import TotalAmount from "./TotalAmount";

const Donation = () => {
  const { donationId } = useParams();
  const donation = donations.find((donation) => donation.id === donationId);
  const { poster, rate } = donation || {};

  return (
    <DisplayLayout mainBg="#1CD5C5" footerBg="#FFCCA5">
      <div className="absolute z-40 ksm:h-[90%] ksm:w-[90%]">
        <div
          className="h-[80%] bg-center bg-cover ksm:rounded-t-[40px] kmd:rounded-t-[70px] kxl:rounded-t-[100px]"
          style={{
            backgroundImage: `url('${poster}')`,
          }}
        >
          <TotalAmount />
        </div>
        {rate ? (
          <FixedDonation donation={donation} />
        ) : (
          <DynamicDonation donation={donation} />
        )}
      </div>
      <DonationFooter />
    </DisplayLayout>
  );
};

export default Donation;
